<template>
	<div>
		<AppHeader title="회원 가입" is-history></AppHeader>
		<AppContent>
			<SignupDetail></SignupDetail>
		</AppContent>
	</div>
</template>

<script>
import AppHeader from '@/components/common/AppHeader';
import AppContent from '@/components/common/AppContent';
import SignupDetail from '@/components/SignupDetail';

export default {
	components: {
		AppHeader,
		AppContent,
		SignupDetail,
	},
};
</script>
